<template>
    <div>
        <limitless-page-header></limitless-page-header>

        <div class="content">
            <rednax-datatable
                :url="'/vue/shipping/label_batch'"
                :columns="table_columns"
                :filter="table_filter"
                sort-by="id"
                sort-order="desc"
                @updateFilter="table_filter=$event"
                @rowclick="rowClick"
                :per-page="100"
            >
                <div class="row">
                    <div class="col-lg-3">
                        <input type="text" v-model="table_filter.search" class="form-control" placeholder="Sök...">
                    </div>
                    <div class="col-lg-3">
                        <label-batch-status-filter
                            v-model="table_filter.status_id"
                            :reduce="(opt) => opt.id"
                            placeholder="-- Status --"
                        ></label-batch-status-filter>
                    </div>
                    <div class="col-lg-3">
                        <div class="custom-control custom-checkbox custom-control-inline mt-2">
                            <input id="chk-hide_closed" type="checkbox" class="custom-control-input" v-model="table_filter.hide_closed" :true-value="1" :false-value="0">
                            <label for="chk-hide_closed" class="custom-control-label">Dölj avslutade batcher</label>
                        </div>
                    </div>
                </div>
                <template #cell_status_id="{ row }">
                    <div v-if="statuses[row.status_id]" class="badge text-white" :class="[`bg-${statuses[row.status_id].color}`]">
                        {{ statuses[row.status_id].label }}
                    </div>
                    <div v-else class="badge bg-secondary">
                        {{ row.status_id }}
                    </div>
                </template>
            </rednax-datatable>
        </div> <!-- /content -->
    </div>
</template>

<script>
import LabelBatchStatusFilter from '@components/Filters/LabelBatchStatusFilter.vue';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';
import BackendRepository from '@services/repositories/BackendRepository';
import { formatDateTime } from '@services/Helpers';
import { keyBy } from 'lodash';

export default {
    name: 'LabelBatchList',
    components: {
        LabelBatchStatusFilter,
        LimitlessPageHeader,
        RednaxDatatable,
    },
    mounted() {
        BackendRepository.getLabelBatchStatuses().then((res) => {
            this.statuses = keyBy(res, 'id');
        });
    },
    data: () => ({
        statuses: null,
        table_filter: {
            search: '',
            status_id: null,
            hide_closed: 0,
        },
        table_columns: [
            {
                data: 'id',
                header: '#',
                sortable: true,
            },
            {
                data: 'status_id',
                header: 'Status',
                sortable: true,
            },
            {
                data: 'FullName',
                header: 'Skapad av',
                sortable: true,
            },
            {
                data: 'item_count',
                header: 'Antal ordrar',
                sortable: true,
            },
            {
                data: 'created_at',
                header: 'Skapad',
                sortable: true,
                render(row) {
                    return formatDateTime(row.created_at).substring(0, 16);
                },
            },
            {
                data: 'updated_at',
                header: 'Ändrad',
                sortable: true,
                render(row) {
                    return formatDateTime(row.updated_at).substring(0, 16);
                },
            },
        ],
    }),
    methods: {
        rowClick(data, event) {
            if (event.metaKey === true || event.ctrlKey === true) {
                const route = this.$router.resolve({ name: 'shipping.label_batch', params: { id: data.id } });
                window.open(route.href, '_blank').focus();
            } else {
                this.$router.push({ name: 'shipping.label_batch', params: { id: data.id } });
            }
        },
    },
};

</script>
